<template>
  <div class="rt-input-number" :class="classes">
    <el-input-number v-bind="$attrs" v-on="$listeners" :min="0" />
  </div>
</template>

<script>
export default {
  name: "RtInputNumber",
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    classes() {
      return `rt-input-${this.size}`
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-input-number {
  &.rt-input-large {
    width: 120px;
    height: 40px;
    @{deep} {
      .el-input__inner {
        font-size: 16px;
        line-height: 21px;
      }
    }
  }
  &.rt-input-medium {
    width: 80px;
    height: 32px;
    @{deep} {
      .el-input__inner {
        font-size: 14px;
        line-height: 19px;
      }
    }
  }
  &.rt-input-small {
    width: 64px;
    height: 24px;
    @{deep} {
      .el-input__inner {
        font-size: 14px;
        line-height: 19px;
      }
    }
  }
  @{deep} {
    .el-input-number {
      width: 100%;
      height: 100%;
      &.is-disabled {
        .el-input-number__increase:hover:not(.is-disabled)
          ~ .el-input
          .el-input__inner:not(.is-disabled),
        .el-input-number__decrease:hover:not(.is-disabled)
          ~ .el-input
          .el-input__inner:not(.is-disabled) {
          box-shadow: unset;
          border-color: #ced5e0;
        }
      }
      .el-input-number__decrease,
      .el-input-number__increase {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: unset;
        border: unset;
        width: 24px;
      }
      .el-input__inner {
        height: 100%;
        line-height: 1;
        color: #143e81;
        border-radius: 2px;
        padding-left: 0;
        padding-right: 0;
      }
      .el-input-number__decrease.is-disabled 
      ~ .el-input
       .el-input__inner {
        color: #ced5e0;
      }
      .el-input-number__increase:hover:not(.is-disabled)
        ~ .el-input
        .el-input__inner:not(.is-disabled),
      .el-input-number__decrease:hover:not(.is-disabled)
        ~ .el-input
        .el-input__inner:not(.is-disabled) {
        box-shadow: 0px 0px 2px 1px rgba(199, 228, 255, 1);
        border-color: #1890ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtInputNumber.vue?43a10e18